export default "__VITE_ASSET__DKbHI4xH__"